import { all, fork } from "redux-saga/effects";

function* watchGetAuthInfo() {}

function* Auth() {
  yield all([fork(watchGetAuthInfo)]);
}

export default Auth;
